import {useCallback, useEffect, useRef, useState} from "react";

export default function useIdleReset({enabled, idleSeconds, countdownSeconds, onReset}) {
  const [warningOpen, setWarningOpen] = useState(false);
  const [remaining, setRemaining] = useState(countdownSeconds);
  const idleTimer = useRef(null);
  const countdownTimer = useRef(null);
  const warningOpenRef = useRef(false);

  const clearTimers = useCallback(() => {
    clearTimeout(idleTimer.current);
    clearInterval(countdownTimer.current);
  }, []);

  const arm = useCallback(() => {
    clearTimers();
    warningOpenRef.current = false;
    setWarningOpen(false);
    setRemaining(countdownSeconds);
    if (!enabled) return;
    idleTimer.current = setTimeout(() => {
      warningOpenRef.current = true;
      setWarningOpen(true);
      let value = countdownSeconds;
      countdownTimer.current = setInterval(() => {
        value -= 1;
        setRemaining(value);
        if (value <= 0) {
          clearTimers();
          onReset();
        }
      }, 1000);
    }, idleSeconds * 1000);
  }, [clearTimers, countdownSeconds, enabled, idleSeconds, onReset]);

  useEffect(() => {
    const events = ["pointerdown", "touchstart", "keydown"];
    const handleActivity = () => {
      if (!warningOpenRef.current) arm();
    };
    events.forEach((event) => window.addEventListener(event, handleActivity, {passive: true}));
    arm();
    return () => {
      events.forEach((event) => window.removeEventListener(event, handleActivity));
      clearTimers();
    };
  }, [arm, clearTimers]);

  return {warningOpen, remaining, continueSession: arm};
}
